import { nativeCallsCapability } from '../lib/native-calls';
import { supabase } from './supabaseClient';

/** Route every explicit refresh through the same owner as automatic refresh. */
export async function refreshOwnedSession(): ReturnType<typeof supabase.auth.refreshSession> {
  if (!nativeCallsCapability()) return supabase.auth.refreshSession();
  const host = window as Window & {
    flutter_inappwebview?: { callHandler(name: string, payload: unknown): Promise<unknown> };
  };
  const bridge = host.flutter_inappwebview;
  if (!bridge) throw new Error('Native session owner unavailable');
  const result = await bridge.callHandler('jemaCallsV2', { version: 1, type: 'refreshSession' });
  const value = result as {
    access_token?: unknown;
    refresh_token?: unknown;
    expires_at?: unknown;
  } | null;
  if (
    !value ||
    typeof value.access_token !== 'string' ||
    !value.access_token ||
    typeof value.refresh_token !== 'string' ||
    !value.refresh_token ||
    typeof value.expires_at !== 'number' ||
    value.expires_at <= Date.now() / 1000
  )
    throw new Error('Native session refresh unavailable');
  return supabase.auth.setSession({
    access_token: value.access_token,
    refresh_token: value.refresh_token,
  });
}
